import React from 'react'
import { useNotificationsController } from './NotificationsController'
import { NotificationsView } from './NotificationsView'

const NotificationsPage: React.FC = () => {
    const controller = useNotificationsController()
    return <NotificationsView {...controller} />
}

export default NotificationsPage
